import { ReactNode, useCallback, useMemo, useState } from "react";
import { currentRelease } from "./releases";
import { WhatsNewContext } from "./whatsNewContext";
import { markReleaseSeen, shouldShowRelease } from "./whatsNewStorage";
import WhatsNewModal from "./WhatsNewModal";

/** Abre as novidades enquanto a versão atual não foi fechada neste navegador e permite reabrir depois. */
export function WhatsNewProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(() => shouldShowRelease(currentRelease.id));

  const openWhatsNew = useCallback(() => setOpen(true), []);

  const closeWhatsNew = useCallback(() => {
    markReleaseSeen(currentRelease.id);
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({ available: true, releaseTitle: currentRelease.title, openWhatsNew }),
    [openWhatsNew],
  );

  return (
    <WhatsNewContext.Provider value={value}>
      {children}
      <WhatsNewModal release={currentRelease} open={open} onClose={closeWhatsNew} />
    </WhatsNewContext.Provider>
  );
}

export default WhatsNewProvider;
